import { BehaviorSubject } from 'rxjs';
import { some } from 'lodash-es';
import Handlebars from 'handlebars';

export type ShareGroupData = {
    id: number;
    name: string;
}
    
export class Store {
    private view_as : number | null = null;
    private view_as_email : string | null = null;
    private highlight : number | null = null;
    private currentUserEmail: string = '';
    private shareGroups: ShareGroupData[] = [];
    private templates : {[key: string]: any} = {};


    addShareGroup(id: number, name:string) {
        this.shareGroups.push({id: id, name:name});
    }

    getShareGroups(): ShareGroupData[] {
        return this.shareGroups;
    }

    getViewAs(): number | null {
        return this.view_as;
    }

    setViewAs(v: number)
    {
        this.view_as = v;
    }

    getViewAsEmail(): string | null {
        return this.view_as_email;
    }

    setViewAsEmail(v: string)
    {
        this.view_as_email = v;
    }

    getHighlight(): number | null {
        return this.highlight;
    }

    setHighlight(h: number)
    {
        this.highlight = h;
    }

    getCurrentUserEmail() {
        return this.currentUserEmail;
    }

    setCurrentUserEmail(e: string) {
        this.currentUserEmail = e;
    }

    getTemplate(name: string)
    {
        if (typeof this.templates[name] == 'undefined')
        {
            const src = document.getElementById(name);
            if (!src) 
            {
                throw new Error(`unable to find element ${name}`); 
            }
            this.templates[name] = Handlebars.compile(src.innerHTML); 
        }
        return this.templates[name];
    }
}

// singleton for store
let _store;
if (!_store) {
    _store = new Store();

    // ONLY for pending_updater as we cant import there
    (window as any).store = _store;
}

export const store = _store;
